import React, {useState, useEffect} from 'react';
import Modal from "../ui/modal";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Box from "@material-ui/core/Box";
import ShareInput from "./ShareInput";
import {useMutation, useQuery} from "react-apollo";
import {GET_REFERRAL_POPUP_DATE, UPSERT_REFERRAL_POPUP} from "graphql/referral-popup-date";
import moment from "moment";
import {useSelector} from "react-redux";


const SharePopup = () => {
  const user = useSelector((s) => s.user.user);
  const [showModal, setShowModal] = useState(false);
  const [shareText, setshareText] = useState(
    'WeAdmit is a method-driven, results-based online college counseling program that will guide your child to their perfect-fit college and help them find long-term career success after graduation. www.weadmit.com',
  );

  const [upsertReferralPopup] = useMutation(UPSERT_REFERRAL_POPUP);

  const { data } = useQuery(GET_REFERRAL_POPUP_DATE, {
    variables: { type: 'social_share' },
  });

  useEffect(() => {
    if (data) {
      if (!data.show_popup_referral.length) {
        setShowModal(true);
      } else {
        const { show_popup_referral: [item] } = data;
        const currentDate = moment();
        const popupDate = item.popup_date;
        const waitDays = item.wait_days || 7;
        const diff = moment(currentDate).diff(popupDate, 'days');
        if (diff >= waitDays) {
          setShowModal(true);
        }
      }
    }
  }, [data]);

  const onShareInputChange = (e) => {
    setshareText(e.target.value);
  };

  const handleClose = () => {
    setShowModal(false);
    upsertReferralPopup({
      variables: {
        user_id: user.id,
        type: 'social_share',
        popup_date: moment().format('YYYY-MM-DD'),
        waitDays: 7,
      },
    }).catch(e => console.log(e));
  }

  return (
    <>
      <Modal
        fullWidth
        title="Tell your friends about joining WeAdmit!"
        open={showModal}
        maxWidth="sm"
      >
        <Box>
          <Box>
            <IconButton
              onClick={handleClose}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box display="flex" alignItems="center" justifyContent="center">
            <Box>
              <ShareInput
                onChange={onShareInputChange}
                multiline
                fullWidth
                value={shareText}
              />
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default SharePopup;